import DatosPersonalesConsulta from './DatosPersonalesConsulta';

export default DatosPersonalesConsulta;
